import { render, staticRenderFns } from "./speechmodel.vue?vue&type=template&id=270d82a0&scoped=true&"
import script from "./speechmodel.vue?vue&type=script&lang=js&"
export * from "./speechmodel.vue?vue&type=script&lang=js&"
import style0 from "./speechmodel.vue?vue&type=style&index=0&id=270d82a0&prod&scoped=true&lang=css&"
import style1 from "./speechmodel.vue?vue&type=style&index=1&id=270d82a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d82a0",
  null
  
)

export default component.exports